import { modalsSlice } from './modals.reducer';
import * as selectors from './modals.selectors';

export { modalsSlice } from './modals.reducer';

export const modalsActions = modalsSlice.actions;

export const modalsSelectors = selectors;
